import { useId, useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import './SearchBox.css'

interface Props {
  compact?: boolean
  autoFocus?: boolean
  initialQuery?: string
}

export function SearchBox({ compact, autoFocus, initialQuery = '' }: Props) {
  const id = useId()
  const navigate = useNavigate()
  const [q, setQ] = useState(initialQuery)

  function onSubmit(e: FormEvent) {
    e.preventDefault()
    const trimmed = q.trim()
    if (!trimmed) return
    navigate(`/search?q=${encodeURIComponent(trimmed)}`)
  }

  return (
    <form className={`search-box ${compact ? 'search-box--compact' : ''}`} onSubmit={onSubmit} role="search">
      <label className="sr-only" htmlFor={id}>
        தேடுக — பாடல், ஸ்துதி, தெய்வம்
      </label>
      <input
        id={id}
        type="search"
        name="q"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="aigiri nandini"
        autoFocus={autoFocus}
        enterKeyHint="search"
        autoComplete="off"
      />
      <button type="submit" className="btn btn--primary search-box__btn">
        தேடு
      </button>
    </form>
  )
}
